export default "__VITE_ASSET__CxBch3eu__"